import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=5234d705&scoped=true&"
import script from "./serveList.vue?vue&type=script&lang=js&"
export * from "./serveList.vue?vue&type=script&lang=js&"
import style0 from "./serveList.vue?vue&type=style&index=0&id=5234d705&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234d705",
  null
  
)

export default component.exports